/**
 * Validate a post-login `returnTo` value: it must be an app-relative path (starts with a single `/`, no
 * protocol-relative `//`, no `://` after decoding). Anything else falls back to the dashboard.
 */
export function validateReturnTo(value: string | null | undefined): string {
  if (!value) return '/dashboard';
  try {
    const decoded = decodeURIComponent(value);
    if (value.startsWith('/') && !value.startsWith('//') && !decoded.includes('://')) {
      return value;
    }
  } catch {
    // decodeURIComponent threw — invalid encoding
  }
  return '/dashboard';
}
